<script lang="ts" setup>
import { defineEmits, ref } from 'vue'

const inputRef = ref<HTMLButtonElement | null>(null)

const handleClick = () => {
  inputRef.value?.click()
}

export interface FileUploadButtonEmits {
  (e: 'add', files: File): void
}

const emit = defineEmits<FileUploadButtonEmits>()

const handleFileUpload = (e: any) => {
  const fileList = e.target.files as FileList
  const files = Array.from(fileList)
  files.forEach((file) => {
    emit('add', file)
  })
}
</script>


<template>
  <IDSKButton v-bind="$attrs" data-test-id="upload-file" @click="handleClick">
    <slot />
  </IDSKButton>
  <input ref="inputRef" type="file" style="display: none" @change="handleFileUpload" />
</template>

<style lang="scss">

</style>
